function CardDepositions() {
  return (
    <div className="d-flex-column cardDepositions">
      <div className="pgrid" />
      <div className="d-flex-row infoDepositions">
        <img className="photoPersonDeposition" alt="" />
        <div className="infoDepositionName">
          <h1 className="subTitle">Lucas Lima</h1>
          <p className="paragraph personPosition">Gamer e UI Desinger</p>
        </div>
      </div>
      <div className=" d-flex-column contentComment">
        <em className="paragraph-2 ct-neutral-100 contentDeposition">
          Lorem ipsum dolor sit amet consectetur. Turpis proin tristique non
          turpis. Amet viverra tincidunt nunc pulvinar mattis Lorem ipsum dolor
          sit amet consectetur. Turpis proin tristique non turpis. Amet viverra
          tincidunt nunc pulvinar mattis Lorem ipsum dolor sit amet consectetur.
          Turpis proin tristique non turpis. Amet viverra tincidunt nunc
          pulvinar mattis{" "}
        </em>
        <span className="tagFromTheCompany">
          Empresa <span className="company">Nova Rota Do Oeste</span>
        </span>
      </div>
    </div>
  );
}

export default CardDepositions;
